import ServiceExec from '@/common/utils/ServiceExec';
import { boardAPI } from '@/common/service/ApiList';

export default {
  async fetchAdminNotice({ commit, state }, payload) {
    const { page, limit, totalPage } = state;
    if (page > totalPage) return;

    let data = {};
    let status = '';

    if (payload && payload.page && payload.totalPage) {
      const response = await ServiceExec.get(boardAPI.notice, {
        page: payload.page,
        limit: payload.limit,
        forAdmin: true
      });
      data = response.data;
      status = response.status;
    } else {
      const response = await ServiceExec.get(boardAPI.notice, {
        page: page,
        limit: limit,
        forAdmin: true
      });
      data = response.data;
      status = response.status;
    }

    const { pageInfo, list } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);

    commit('setAdminNoticeList', list);
  },

  async fetchMainBoard({ commit }, payload) {
    const notice = await ServiceExec.get(boardAPI.notice, payload);
    if (notice.status === 200) {
      commit('setMainNoticeList', notice.data.list);
    }

    const event = await ServiceExec.get(boardAPI.event, payload);
    if (event.status === 200) {
      commit('setMainEventList', event.data.list);
    }
  },
  async FETCH_EVENT({ commit }, payload) {
    const event = await ServiceExec.get(boardAPI.event, payload, { ...payload });
    if (event.status === 200) {
      commit('setMainEventList', event.data.list);
    }
  },
  async FETCH_NOTICE({ commit }, payload) {
    const notice = await ServiceExec.get(boardAPI.notice, payload, { ...payload });
    if (notice.status === 200) {
      commit('setMainNoticeList', notice.data.list);
    }
  },

  async fetchBoardList({ state, commit }, payload) {
    if (payload === 'notice') {
      const { page, limit, totalPage } = state.notice;
      if (page > totalPage) return;
      const { data } = await ServiceExec.get(boardAPI.notice, {
        page: page,
        limit: limit,
        forAdmin: false
      });
      const { list, pageInfo } = data;
      commit('setNoticePage', page + 1);
      commit('setNoticeTotalPage', pageInfo?.totalPage ?? 2);
      commit('setNoticeList', list ?? []);
    }

    if (payload === 'event') {
      const { page, limit, totalPage } = state.event;
      if (page > totalPage) return;
      const { data, status } = await ServiceExec.get(boardAPI.event, {
        page,
        limit
      });
      const { list, pageInfo } = data;
      commit('setEventPage', page + 1);
      commit('setEventTotalPage', pageInfo?.totalPage ?? 2);
      commit('setEventList', list ?? []);
    }
  },

  async event_detail({ commit }, eventNo) {
    const { data } = await ServiceExec.get(boardAPI.event_detail(eventNo));
    if (data) commit('setEvent', data);
  },

  async notice_detail({ commit }, noticeNo) {
    const { status, data } = await ServiceExec.get(boardAPI.notice_detail(noticeNo));
    if (status === 200) commit('setNotice', data);
  },

  async admin_notice_detail({ commit }, noticeNo) {
    const { data } = await ServiceExec.get(boardAPI.notice_detail(noticeNo));
    if (data) commit('setDetail', data);
  },

  async fetchBoard({ commit }, payload) {
    if (payload.boardType === 'notice') commit('setNotice', payload.board);
    if (payload.boardType === 'event') commit('setEvent', payload.board);
  }
};
